<ul class="tw-flex tw-flex-wrap tw-items-center">
  @for (action of processedActions(); track action) {
    <li class="guts-m-b-1 guts-m-r-1 tw-flex" data-dgat="globalAdd-cd7">
      <button
        type="button"
        class="tw-btn-small tw-btn-secondary-outline"
        (click)="action.handlerFn($event, action)"
        [attr.id]="action.id"
        [attr.data-dgat]="action.dgat"
        [attr.aria-label]="action.displayType"
      >
        @if (action.icon) {
          <da-icon
            [icon]="action.icon"
            type="solid-small"
            class="tw-reset tw-inline-block tw-align-middle"
          />
        }
        {{ action.displayType }}
      </button>
    </li>
  }
</ul>
